var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('div',[(_vm.dataList[0].married != 2 && _vm.dataList[0].married != 3 && _vm.dataList[0].married != 5)?_c('Spouse',{attrs:{"data":_vm.data}}):_vm._e(),_c('Children',{attrs:{"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }